import {
    ChangeDetectionStrategy,
    Component,
    EventEmitter,
    Input,
    OnChanges,
    Output,
    ViewChild,
    ViewEncapsulation,
} from '@angular/core';
import { MatTabGroup } from '@angular/material/tabs';
import { ITabItem } from '@fi-app/utilities/tabs/tabs';
import { isNullOrUndefined } from 'util';

@Component({
    selector: 'fi-tabs',
    templateUrl: './tabs.component.html',
    styleUrls: ['./tabs.component.scss'],
    encapsulation: ViewEncapsulation.None,
    changeDetection: ChangeDetectionStrategy.OnPush,
    host: { class: 'fi-tabs' },
    standalone: false,
})
export class TabsComponent implements OnChanges {
    protected readonly tabsComponentClassName = 'fi-tabs'; // note: must match with host: { 'class': ... }
    @Input() tabsModel: ITabItem[];
    @Input() selectedIndex = 0;
    @Output() selectedIndexChange = new EventEmitter<number>();

    @ViewChild(MatTabGroup, { static: true }) matTabGroup: MatTabGroup;

    selectIndex($event) {
        this.selectedIndexChange.emit($event);
    }

    swipeLeft($event) {
        if ($event.target.tagName.toLowerCase() == 'input') {
            $event.stopPropagation();
            return;
        }

        if (this.selectedIndex < this.tabsModel.length) {
            this.selectedIndex++;
            this.selectIndex(this.selectedIndex);
        }
    }

    swipeRight($event) {
        if ($event.target.tagName.toLowerCase() == 'input') {
            $event.stopPropagation();
            return;
        }

        if (this.selectedIndex > 0) {
            this.selectedIndex--;
            this.selectIndex(this.selectedIndex);
        }
    }

    ngOnChanges() {
        if (!isNullOrUndefined(this.matTabGroup)) this.matTabGroup.selectedIndex = this.selectedIndex;
    }
}
